import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  SeatUsageByLicenseTypeMapping: {
    fields: {
      member: {
        merge: true,
      },
      guest: {
        merge: true,
      },
    },
  },
};
